export const shareActionIconCss = {
  "path:not(:last-of-type)": {
    stroke: "currentColor",
  },

  "path:last-of-type": {
    strokeWidth: 0,
    fill: "currentColor",
  },
};
